import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/style-component/components/buttonStyle.js";
import PropTypes from "prop-types";
import React from "react";
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";
const useStyles = makeStyles(styles);

export default function RegularButton(props) {
  const {
    color,
    //round,
    children,
    //disabled,
    //simple,
    //size,
    //block,
    //link,
    //justIcon,
    className,
    muiClasses,
    loading,
    ...rest
  } = props;
  const btnClasses = estilos(useStyles(), props, "boton");
  return (
    <Button {...rest} classes={muiClasses} className={btnClasses}>
      {!loading && children}
    </Button>
  );
}

RegularButton.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "default",
    "inherit",
    "secondary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "transparent",
    "cabecera"
  ]),
  size: PropTypes.oneOf(["sm", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  className: PropTypes.string,
  // use this to pass the classes props from Material-UI
  muiClasses: PropTypes.object,
  children: PropTypes.node,
  loading: PropTypes.bool
};
